export const Pointer = ({ orientation }: { orientation: 'left' | 'right' }) => (
  <svg
    fill="none"
    height="100%"
    preserveAspectRatio="none"
    style={{
      transform: orientation === 'left' ? 'rotate(180deg)' : 'none',
      zIndex: 1,
    }}
    viewBox="0 0 225 82"
    width="225"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_2002_831)">
      <rect fill="#022E4A" height="74" rx="8" transform="rotate(-180 212 76)" width="208" x="212" y="76" />
      <path
        d="M220.5 37.634C221.167 38.0189 221.167 38.9811 220.5 39.366L206.25 47.5933C205.583 47.9782 204.75 47.497 204.75 46.7272L204.75 30.2728C204.75 29.503 205.583 29.0218 206.25 29.4067L220.5 37.634Z"
        fill="#022E4A"
      />
    </g>
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="82"
        id="filter0_d_2002_831"
        width="225"
        x="0"
        y="0"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_2002_831" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_2002_831" mode="normal" result="shape" />
      </filter>
    </defs>
  </svg>
);
